import React from "react";
import PropertyCardCarousel from "@/components/PropertyCardCarousel";
import { usePropertyGallery } from "@/lib/propertyGalleries";

// -----------------------------------------------------------------------------
//  SyncedPropertyCarousel
//  Thin wrapper around <PropertyCardCarousel /> that reads its image list from
//  the shared property-gallery hook (`usePropertyGallery`). Isolating the hook
//  call here keeps <ContactPage> / <BookingPage> free of per-iteration hook
//  calls (which violates React's Rules of Hooks inside `.map()`) while still
//  guaranteeing every card carousel picks up CMS edits made through
//  /admin/galleries → "Hotel card images".
// -----------------------------------------------------------------------------

const SyncedPropertyCarousel = ({ slug, ...carouselProps }) => {
  const images = usePropertyGallery(slug);
  return <PropertyCardCarousel images={images} {...carouselProps} />;
};

export default SyncedPropertyCarousel;
